<template>
  <div class="w-full">
    <div class="flex gap-2 mb-4 justify-center flex-wrap" v-if="showButton">
      <button
        v-for="tab in tabs"
        :key="tab.id"
        class="px-6 py-2.5 rounded-lg font-medium text-base transition-colors duration-200 border border-gray-200 focus:outline-none"
        :class="[
          activeTab === tab.id
            ? 'bg-primary text-white border-primary'
            : 'bg-white text-gray-500 hover:bg-gray-50',
        ]"
        @click="setActiveTab(tab.id)"
      >
        {{ tab.label }}
      </button>
    </div>
    <div class="py-4">
      <slot :name="activeTab"></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineEmits, defineProps, ref } from "vue";

interface Tab {
  id: string;
  label: string;
}

const props = defineProps({
  tabs: Array as () => Tab[],
  initialTab: {
    type: String,
    required: true,
  },
  showButton: {
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits<{
  (e: "change", tabId: string): void;
}>();

const activeTab = ref(
  props.initialTab || (props.tabs.length > 0 ? props.tabs[0].id : ""),
);

const setActiveTab = (tabId: string) => {
  activeTab.value = tabId;
  emit("change", tabId);
};
</script>
